function ToS() {
    return (
        <div>
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Terms of Service</h2>
            <p className="text-gray-700 mb-6">
                <strong>Last Updated:</strong> 17 November 2025
            </p>

            <div className="space-y-6">
                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">1. Overview</h3>
                    <p className="text-gray-700 mb-2">
                        Origins Bot ("the Bot") is a Discord bot designed for Habbo Hotel: Origins communities.
                        These Terms of Service ("Terms") govern the use of the Bot by:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>Server Owners / Administrators ("Server Owners") who install and configure the Bot</li>
                        <li>End Users ("Users") who interact with the Bot, including linking their Discord and Habbo accounts</li>
                    </ul>
                    <p className="text-gray-700 mt-2">
                        By installing, enabling, or using the Bot, you agree to these Terms.
                    </p>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">2. Eligibility</h3>
                    <p className="text-gray-700 mb-2">
                        The Bot is intended for communities related to Habbo Hotel: Origins, an 18+ game. Therefore:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>Server Owners must be 18 years or older</li>
                        <li>Users verifying accounts must also be 18 years or older</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">3. Use of the Bot</h3>
                    <p className="text-gray-700 mb-2">
                        You may use the Bot only for lawful purposes and in accordance with Discord's Terms of Service
                        and Community Guidelines. Prohibited uses include:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>Attempting to impersonate another user</li>
                        <li>Providing false information during verification</li>
                        <li>Attempting to access or manipulate the Bot, its database, or its functionality</li>
                        <li>Using the Bot for harassment, abuse, or evasion of server moderation</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">4. Responsibilities of Server Owners</h3>
                    <p className="text-gray-700 mb-2">
                        By adding the Bot to your server, Server Owners agree to:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>Ensure your server complies with Discord's rules</li>
                        <li>Inform your members that the Bot is present and may process data as described in the Privacy Policy</li>
                        <li>Not use the Bot for purposes other than moderation, logging, verification, and community management</li>
                        <li>Remove the Bot if you no longer agree to these Terms</li>
                    </ul>
                    <p className="text-gray-700 mt-3 mb-2">
                        Server Owners also acknowledge that:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>The Bot may store server IDs, channel/thread IDs, role IDs, and related metadata</li>
                        <li>The Bot never stores message content, only data required for logging events inside the server where the events occur</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">5. Responsibilities of End Users</h3>
                    <p className="text-gray-700 mb-2">
                        Users who link their Habbo and Discord accounts agree that:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>They will provide accurate information</li>
                        <li>They may unlink and delete their data at any time</li>
                        <li>By using the verification system, they agree to the Privacy Policy</li>
                    </ul>
                    <p className="text-gray-700 mt-3 mb-2">
                        Users must not:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>Verify someone else's Habbo account</li>
                        <li>Attempt to bypass verification or impersonate another person</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">6. Availability</h3>
                    <p className="text-gray-700 mb-2">
                        You understand that:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>The Bot is provided on an "as is" and "as available" basis</li>
                        <li>Downtime, bugs, or outages may occur</li>
                        <li>Features may change or be removed without notice</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">7. Limitation of Liability</h3>
                    <p className="text-gray-700 mb-2">
                        Origins Bot is a hobby project and is provided without warranty of any kind. To the fullest
                        extent permitted by law:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                        <li>The Bot owner is not liable for damages arising from use or inability to use the Bot</li>
                        <li>The Bot owner is not responsible for actions taken by server moderators or users</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">8. Termination</h3>
                    <p className="text-gray-700">
                        You may stop using the Bot at any time. Server Owners may remove the Bot from their server at any time.
                        The Bot owner may suspend or terminate access at their discretion if misuse is detected.
                    </p>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">9. Changes to These Terms</h3>
                    <p className="text-gray-700">
                        Terms may be updated occasionally. The "Last Updated" date will change when updates occur.
                        Continued use of the Bot after changes constitutes acceptance of the updated Terms.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default ToS;